import React from 'react'
import { NavLink } from 'react-router-dom'

import { Modal } from '../../../components/ui'
import { Button } from '../../../components/ui/legacy'

function SignOutConfirmation({ onCancel, onSignOut }) {
  return (
    <Modal
      onClose={onCancel}
      className={'w-[200] rounded-md border-[1px] bg-white'}
    >
      <h1 className="mx-4 my-8 text-lg font-bold">Xác nhận đăng xuất?</h1>
      <div className="my-4 flex w-full items-center justify-between gap-2 px-4">
        <Button variant={'tertiary'} onClickHandler={onCancel}>
          Huỷ
        </Button>
        <Button variant={'primary'} onClickHandler={onSignOut}>
          <NavLink to="/login">Đăng xuất</NavLink>
        </Button>
      </div>
    </Modal>
  )
}

export default SignOutConfirmation
// navigateToLoginRequestUrl: true,
